var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 5.37331C5.00062 5.495 4.97961 5.61562 4.93817 5.72827C4.89673 5.84092 4.83567 5.94337 4.75849 6.02977L1.42743 9.72809C1.34979 9.8143 1.25761 9.88268 1.15616 9.92933C1.05471 9.97599 0.945978 10 0.83617 10C0.726363 10 0.61763 9.97599 0.516181 9.92933C0.414732 9.88268 0.322554 9.8143 0.244908 9.72809C0.167263 9.64188 0.105671 9.53954 0.0636492 9.42691C0.0216277 9.31427 1.04117e-07 9.19355 1.2174e-07 9.07164C1.39364e-07 8.94972 0.0216278 8.829 0.0636493 8.71637C0.105671 8.60373 0.167263 8.50139 0.244909 8.41518L3.00136 5.37331L0.353169 2.3222C0.267985 2.23714 0.199525 2.13349 0.152069 2.01772C0.104613 1.90195 0.079183 1.77656 0.0773682 1.64938C0.0755534 1.5222 0.0973928 1.39597 0.141522 1.27859C0.185651 1.16121 0.25112 1.0552 0.333834 0.967197C0.416547 0.87919 0.514727 0.811076 0.622232 0.767119C0.729737 0.723162 0.844254 0.704305 0.958623 0.711727C1.07299 0.71915 1.18475 0.752693 1.28691 0.810258C1.38907 0.867823 1.47943 0.94817 1.55235 1.04628L4.76681 4.7446C4.91364 4.91368 4.99701 5.13847 4.99999 5.37331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.42daf592d954ddd40757b6990374c17b.svg";
export { ForwardRef as ReactComponent };